import PreLoader from "../../../components/PreLoader/PreLoader";
import styles from "./ProductPageBody.module.css";
import React from "react";
import Specifications from "./Specifications.jsx";

const ProductPageBody = ({ product }) => {
  if (!product) return <PreLoader />;

  const {
    name,
    title,
    img,
    subtitle,
    portfolio,
    desc,
    review,
    specifications,
  } = product;

  return (
    <>
      <div className={styles.productBodyCont}>
        <h2>{portfolio}</h2>
        <p className={styles.productBodyDesc}>{desc}</p>
        <p className={styles.productBodyReview}>{review}</p>
        <Specifications specifications={specifications} />
      </div>
    </>
  );
};
export default ProductPageBody;
